import { render, staticRenderFns } from "./SegmentControl.vue?vue&type=template&id=60827438&scoped=true&lang=html&"
import script from "./SegmentControl.vue?vue&type=script&lang=js&"
export * from "./SegmentControl.vue?vue&type=script&lang=js&"
import style0 from "./SegmentControl.vue?vue&type=style&index=0&id=60827438&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60827438",
  null
  
)

export default component.exports